import React from "react";
import styled from "styled-components";
import { fontSizing, media, spacing, gradientBackground } from "./theme";
import TopBox from "./common/TopBox";
import { RouteName, RouteParams } from "../lib/routes";
import { Media, MediaRef } from "../lib/CmsApi";
import staticMedia from "../lib/static";
import { DEFAULT_PADDING } from "./common/Content";

const overlap = 100;
const Wrapper = styled.div`
  display: flex;
  align-items: flex-start;
  overflow: hidden;
  @media ${media.desktop} {
    margin-bottom: -${overlap - 32}px;
  }
`;
const Claim = styled.div`
  height: 100%;
  max-width: none;
  width: 50vw;
  ${gradientBackground};
  padding-bottom: ${overlap}px;
  ${spacing("padding-top", 48)}
  padding-left:4vw;
  padding-right: 4vw;
  ${fontSizing("headline", 32)}
  color: #fff;
  @media ${media.tablet} {
    ${spacing("padding-bottom", 48)}
    width: 100vw;
    margin-left: -${DEFAULT_PADDING};
    padding-left: ${DEFAULT_PADDING};
  }
`;
const ClaimIcon = styled.img`
  width: 60%;
  height: 100px;
  ${spacing("padding-bottom", 32)}
  @media ${media.tablet} {
    width: 20%;
    height: auto;
  }
`;
const ClaimText = styled.div`
  font-size: 24px;
  @media ${media.tablet} {
    font-size: 20px;
  }
`;
const NoGrow = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 328px;
  width: 100%;
`;
interface Props {
  headline: string;
  intro: string;
  claim?: string;
  icon?: MediaRef & Media;
  breadCrumpPath: { route: RouteName; params?: RouteParams; title: string }[];
}
export default function IntroHeader(props: Props) {
  return (
    <Wrapper>
      <TopBox
        title={props.headline}
        intro={props.intro}
        breadCrumpPath={props.breadCrumpPath}
        overlap={overlap}
        infoBoxTop
        infoBoxTopOnTablet
        infoBoxBlock
        infoBox={
          <Claim>
            <NoGrow>
              {props.icon && (
                <ClaimIcon src={staticMedia(props.icon)} alt="" role="none" />
              )}{" "}
              <ClaimText>{props.claim}</ClaimText>
            </NoGrow>
          </Claim>
        }
      />
    </Wrapper>
  );
}

IntroHeader.getImages = (p: Partial<Props>) => {
  return p.icon ? [p.icon] : [];
};
